import React from "react";

const PayLinks = () => {
  return (
    <div>
      <h1 className="text-warning text-center rounded bg-secondary m-1">Comming Soon. Sorry for late</h1>
      <img className="img-fluid rounded centre" src="https://cdn.pixabay.com/photo/2016/12/11/08/01/coming-soon-1898936__340.jpg" alt=""/>
    </div>
  );
};

export default PayLinks;
